import { QuoteExtra } from '~/lib/types/basket-types';
import { Protection, ProtectionPrefix } from '../types/extra-types';

export const GetUpdatedQuoteProtectionExtras = (
  extraKey: string,
  addExtra: boolean,
  sectionExtras: QuoteExtra[],
  initialSelectedProtection: QuoteExtra[]
): QuoteExtra[] => {
  if (addExtra) {
    if (extraKey === Protection.NONE) {
      return [...sectionExtras.filter((e) => !e.key.startsWith(ProtectionPrefix))];
    } else {
      return [...sectionExtras.filter((e) => !e.key.startsWith(ProtectionPrefix)), { key: extraKey, metadata: {} }];
    }
  } else {
    return sectionExtras
      .filter((e) => !e.key.startsWith(ProtectionPrefix))
      .concat(initialSelectedProtection.filter((e) => e.key == Protection.BASE));
  }
};

export const ResetQuoteProtectionExtras = (
  sectionExtras: QuoteExtra[],
  initialSelectedProtection: QuoteExtra[]
): QuoteExtra[] => {
  return sectionExtras
    .filter((e) => !e.key.startsWith(ProtectionPrefix))
    .concat(initialSelectedProtection.filter((e) => e.key == Protection.BASE));
};
